<template>
  <div class="itemInner notranslate">
    <div class="itemOption">
      <div class="priceInfo notranslate">
        <div class="byQuantity row">
          <div class="item">
            <div class="label toCapitalize">
              <span class="thumb"><img :src="amenityThumb(itemData.raCode)" alt=""></span>
              <span>{{amenityName(itemData)}}</span> ({{itemData.count}})
            </div>
            <div v-if="itemData.price" class="value">{{priceFormat(itemData.price)}}</div>
          </div>
          <div v-if="itemData.price && itemData.price.info && itemData.price.info.total !== 0" class="item price">
            <span class="label toCapitalize">{{locale.total}}</span>
            <span class="value">{{priceFormat(itemData.price.info.total)}}</span>
          </div>
        </div>
      </div>
      <!-- //price -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderItemAmenity',
  props: [
    'itemData',
    'lang',
    'locale',
    'localeAmenity',
    'noLink'
  ],
  methods: {
    amenityThumb (raCode) {
      const image = `${raCode.toLowerCase()}.png`
      return `${process.env.BASE_URL}img/amenity/${image}`
    },
    amenityName (order) {
      const lang = this.$route.params.ln
      const code = this.itemData.raCode.toLowerCase()
      return this.itemData.label && typeof (this.itemData.label) === 'object'
        ? this.itemData.label[lang]
        : this.localeAmenity[`amenity_${code}`]
    }
  }
}
</script>

<style lang="scss" scoped>
.cartItem .priceInfo {
  margin: 0;
}
.cartItem {
  .thumb {
    display: inline-block;
    width: 32px;
    height: 32px;
    padding: 3px;
    vertical-align: middle;
    img {
      position: static;
    }
  }
}
</style>
